import React from "react";
import { Link } from "react-router-dom";
import cover from "../../assets/images/alluratech-cover-matchxr.png";

const MatchXREventSection: React.FC = () => (
  <section className="matchxr-section" aria-labelledby="matchxr-title" id="matchxr-2026">
    <div className="matchxr-inner">
      <div className="matchxr-copy">
        <span className="matchxr-label">AlluraTech at MatchXR 2026</span>
        <h2 id="matchxr-title">Meet us in Helsinki</h2>
        <p className="matchxr-lead">
          We’re exhibiting at MatchXR 2026. Come connect with the team behind
          AlluraXR and explore how immersive experiences, creator tools, and
          practical collaboration can move ideas forward.
        </p>
        <div className="matchxr-facts">
          <span><strong>12 November 2026</strong> · Metropolia Arabia Campus</span>
          <span>Hämeentie 135 D, Helsinki</span>
        </div>
        <div className="matchxr-actions">
          <a href="https://matchxr.fi/attend/" target="_blank" rel="noopener noreferrer">Event details <span aria-hidden="true">↗</span></a>
          <Link to="/contact">Get in touch</Link>
        </div>
      </div>
      <img src={cover} alt="Illustrated Helsinki waterfront with a luminous blue gateway" loading="lazy" />
    </div>
  </section>
);

export default MatchXREventSection;
